
import 'swiper/css/swiper.css'
import { Component, Vue } from 'vue-property-decorator'
import { MemberIVO } from '@/views/biz/join/vo/join.vo'
import axios from 'axios'
import Constants from '@/constants';
import CommonUtils from '@/common-utils';

@Component
export default class SignUp3 extends Vue{

  member: MemberIVO = {} as MemberIVO;
  checkPwd = '';
  tmpId = '';
  isMailing = false;

  isValidationMemId = false;
  isValidationMemPwd = false;
  isValidationMemPwd2 = false;
  isValidationMemMail = false;
  isCheckDuplicationMemId = false;
  isPassedValidation = false;
  isDuplicateMemId = false;

  emailId = '';
  emailAddress = '';
  selectEmailAddress = '';
  
  // 아이디 검증
  get validateMemberId() {
    // 등록 가능한 아이디 입니다.
    let message = this.$t('join.t0001').toString();
    this.isValidationMemId = true;
    
    if(this.tmpId != this.member.memId) {
      this.isCheckDuplicationMemId = false;
    }

    if(this.isDuplicateMemId == true) {
      //중복된 아이디가 존재합니다.
      message = this.$t('join.a0019').toString();
      this.isValidationMemId = false;
      return message;
    }

    if(this.isCheckDuplicationMemId == false) {
      //아이디 중복확인을 해주세요.
      message = this.$t('join.t0009').toString();
      this.isValidationMemId = false;
    }

    if(Constants.REGEXP_ID.test(this.member.memId) == false) {
      // 영문 또는 숫자 조합(5~15자리)
      message = this.$t('join.t0006').toString();
      this.isValidationMemId = false;
    }

    return message;
  }

  // 비밀번호 검증
  get validateMemberPwd() {
    // 사용 가능한 비밀번호 입니다.
    let message = this.$t('join.t0002').toString();
    this.isValidationMemPwd = true;

    if(CommonUtils.validatePassword(this.member.memPwd) == false) {
      // 비밀번호는 영문과 숫자 조합(8자리 이상)
      message = this.$t('join.t0007').toString();
      this.isValidationMemPwd = false;
    }

    return message;
  }

  // 비밀번호 일치 검증
  get checkSamePassword() {
    // 비밀번호가 일치합니다.
    let message = this.$t('join.t0003').toString();
    this.isValidationMemPwd2 = true;

    if(this.member.memPwd != this.checkPwd) {
      // 비밀번호가 일치하지 않습니다.
      message = this.$t('join.t0005').toString();
      this.isValidationMemPwd2 = false;
    }

    return message;
  }

  // 이메일 검증
  get getMemberEmail() {
    if(this.emailId && this.selectEmailAddress) {
      this.member.memEmail = `${this.emailId}@${this.selectEmailAddress}`;
    }
    
    if(this.emailId && !this.selectEmailAddress) {
      this.member.memEmail = `${this.emailId}@${this.emailAddress}`;
    }

    return this.member.memEmail;
  }

  // 아이디 중복 검사
  checkDuplicationMemId() {
    if(!this.member.memId) {
      return alert(this.$t('join.a0017'));
    }
    
    axios.get(`/join/duplication/${this.member.memId}`)
    .then(r => {
      if(r.data) {
        // 중복된 아이디가 존재합니다.
        this.$toast(this.$t('join.a0019'));
        this.isDuplicateMemId = true;
      } else {
        this.isCheckDuplicationMemId = true;
        this.tmpId = this.member.memId;
        this.isDuplicateMemId = false;
      }
    })
  }


  // 가입 신청
  save() {
    if(this.isValidationMemId == false) {
      // 아이디를 확인해주세요.
      return alert(this.$t('join.a0014'));
    }

    if(this.isValidationMemPwd == false) {
      // 비밀번호를 확인해주세요.
      return alert(this.$t('join.a0015'));
    }

    if(this.isValidationMemPwd2 == false) {
      // 비밀번호를 확인해주세요.
      return alert(this.$t('join.a0015'));
    }

    if(this.getMemberEmail && Constants.REGEXP_EMAIL.test(this.getMemberEmail) == false) {
      // 이메일을 확인해주세요.
      return alert(this.$t('join.a0016'));
    }

    if(this.isCheckDuplicationMemId == false) {
      // 아이디 중복확인을 하셔야 합니다.
      return alert(this.$t('join.a0012'));
    }
    
    // 자신을 추천인으로 등록할 경우
    if(this.member.memId == this.member.refMemId) {
      // 추천인 아이디를 확인하세요.
      return alert(this.$t('join.a0029'));
    }

    if(this.isDuplicateMemId == true) {
      return alert(this.$t('join.a001'));
    }

    // 닉네임은 13자리까지 입력할 수 있습니다.
    if(this.member.memNickNm && this.member.memNickNm.length > 13) {
      return alert(this.$t('join.a0043'));
    }

    this.member.mailingType = this.isMailing ? '01': '02'; //'01': 수신 동의, '02: 수신 미동의

    // 가입 완료 처리
    axios.post('/join/member', this.member)
    .then(r => {
      const rewardPoint = r.data as string;
      this.$router.push({name: 'SignUp4', params: {rewardPoint: rewardPoint, memId: this.member.memId}})
    })
  }

  created() {
    if (window.opener) {
      window.opener.location.href = CommonUtils.createStaticUrl(this, 'SignUp3');
      window.close();
      return;
    }

    axios.get('/join/member-info')
    .then(r => {
      this.member = r.data;
      if(r.data) {
        this.member = r.data;

        // 추천인정보
        const refId = CommonUtils.getLocalStorageObject(Constants.EXTERNAL_PARAM_REF_ID);

        if(refId) {
          this.$set(this.member, 'refMemId', refId);
          this.$set(this.member, 'refMemCd', CommonUtils.getLocalStorageObject(Constants.EXTERNAL_PARAM_REF_MEM_CD) || 0);

          // 까알끔하게 지워준다.
          CommonUtils.removeLocalStorageObject(Constants.EXTERNAL_PARAM_REF_ID);
          CommonUtils.removeLocalStorageObject(Constants.EXTERNAL_PARAM_REF_MEM_CD);
        }

      } else {
        // 본인인증이 필요합니다.
        alert(this.$t('join.a0018'));
        this.$router.push({name: 'SignUp1'})
      }
    })
    .catch(() => {
      this.$router.push({name: 'Login'})
    })
  }
}
